// extracted by mini-css-extract-plugin
export default {"questionContainer":"Question_questionContainer__+q19F","option":"Question_option__5BNWg","question":"Question_question__UHB2K","selected":"Question_selected__CuYKb"};